import { createFileRoute, useNavigate } from "@tanstack/react-router"
import { z } from "zod"
import { FlagsList, flagsListQuery } from "@/features/feature-flags/components/FlagsList"

const flagsSearchParams = z.object({
  search: z.string().optional(),
  includeArchived: z.boolean().optional().default(false),
})

type FlagsSearchParams = z.infer<typeof flagsSearchParams>

export const Route = createFileRoute("/(authenticated)/settings/feature-flags/")({
  validateSearch: flagsSearchParams,
  loaderDeps: ({ search }) => ({
    search: search.search,
    includeArchived: search.includeArchived,
  }),
  loader: ({ context, deps }) => {
    void context.queryClient.ensureQueryData(flagsListQuery(deps))
  },
  component: FeatureFlagsPage,
})

function FeatureFlagsPage() {
  const filters = Route.useSearch()
  const navigate = useNavigate({ from: Route.fullPath })

  const handleFiltersChange = (newFilters: Partial<FlagsSearchParams>) => {
    void navigate({
      search: (prev: FlagsSearchParams) => ({
        ...prev,
        ...newFilters,
      }),
      replace: true,
    })
  }

  return <FlagsList filters={filters} onFiltersChange={handleFiltersChange} />
}
